import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './Table.module.scss';

function Table({ children, className, ...remainingProps }) {
  return (
    <table
      className={classNames(styles.root, className)}
      {...remainingProps}
    >
      {children}
    </table>
  );
}

Table.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default Table;
